import { render, staticRenderFns } from "./ContestTable.vue?vue&type=template&id=2ab50db9&scoped=true&"
import script from "./ContestTable.vue?vue&type=script&lang=js&"
export * from "./ContestTable.vue?vue&type=script&lang=js&"
import style0 from "./ContestTable.vue?vue&type=style&index=0&id=2ab50db9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab50db9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout,VTab,VTabItem,VTabs})
